
import {map} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { DocumentTypeService } from '../services/document-type.service';
import {DocumentType} from '../models/documentType.model';
import { DocumentTypeDataSource } from './document-type.datasource';
import { ConfirmComponent } from '../dialogs/confirm/confirm.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { BasePagedDataSource } from '../base/table/paged-table-base.datasource';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-document-type',
  templateUrl: './document-type.component.html',
  styleUrls: ['./document-type.component.css']
})
export class DocumentTypeComponent implements OnInit {

  dataSource: BasePagedDataSource<DocumentType> = null;
  displayedColumns = ['actions', 'name'];

  constructor(
    private notificationsService: ToastrService,
    private router: Router,
    private typeService: DocumentTypeService,
    private dialog: MatDialog,
    public userService: UserService
  ) {
   }

  ngOnInit() {
    this.loadData();
  }
  OnEdit(type: DocumentType) {
    if ((type.isCommon && this.userService.hasRole('Admin')) || !type.isCommon) {
      this.router.navigate(['/documentType/edit', type.id]);
    }
  }
  private loadData() {
    this.dataSource = new BasePagedDataSource<DocumentType>(this.typeService);
    this.dataSource.loadData();
  }
  private ConrimDelete(id: string): Observable<any> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: 'dialogs.question',
      message: 'dialogMessages.deleteRecord'
    };

    const dialogRef = this.dialog.open(ConfirmComponent, dialogConfig);
    return dialogRef.afterClosed().pipe(map(
      ret => {
        return ret;
      }
    ));
  }
  private ConrimRecreate(id: string): Observable<any> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: 'dialogs.question',
      message: 'dws.dialogMessages.recreateIndex'
    };

    const dialogRef = this.dialog.open(ConfirmComponent, dialogConfig);
    return dialogRef.afterClosed().pipe(map(
      ret => {
        return ret;
      }
    ));
  }

  OnDelete(type: DocumentType) {
    if (type.id) {
      this.ConrimDelete(type.code).subscribe((ret) => {
        if (ret) {
          this.typeService.Delete(type.id).subscribe(() => {
            this.loadData();
          });
        }
      });
    }
  }
  OnAdd() {
    this.router.navigate(['/documentType/add']);
  }
  OnRecreate(type: DocumentType) {
    if (type.id) {
      this.ConrimRecreate(type.code).subscribe((ret) => {
        if (ret) {
          console.log('OnRecreate',type.id);
          this.typeService.recreateIndex(type.id).subscribe();
        }
      });
    }
  }

}
